import { put, call, all, fork, takeEvery, takeLatest, } from 'redux-saga/effects';
import asyncInterface from "../../../../asyncInterface";
import formPoolStructure from "../../../../utils/formPoolStructure";
import { grant } from "../../../../services/apiServices";

import * as actionTypes from './actionTypes';


export function fetchAccountData(fetchPayload) {
  const fetchData = asyncInterface.init();
  return fetchData.grantAgreements.fetchAccountData(fetchPayload);
}

export function postCharityData(fetchPayload) {
  const fetchData = asyncInterface.init();
  return fetchData.recommendGrant.postCharityData(fetchPayload.payload);
}


export function* fetchGrantDetails() {
  yield takeLatest(actionTypes.fetchSpawnsType, grantDetailsWorker);
}


export function* grantDetailsWorker(action) {
  try {
    const response = yield call(grant.findGrantDetailsByAccountIdAndGrantId, action.payload);
    yield put({ type: actionTypes.fetchSpawnSuccessType, payload: response.data });
  } catch (error) {
    yield put({ type: actionTypes.fetchSpawnFailType, error });
  }
}

export function* confirmationDataWorker(fetchPayload) {
  yield put({type: actionTypes.confirmationPageLoadingType});
  try {
    const response = yield call(fetchAccountData, fetchPayload.payload);
    yield put({
      type: actionTypes.confirmationPageSuccessType,
      payload: response.data
    });
  } catch (error) {
    yield put({
      type: actionTypes.confirmationPageFailType,
      error
    });
  }
}

export function* confirmationDataWatcher() {
  yield takeEvery(actionTypes.confirmationPageType, confirmationDataWorker);
}

export function* fetchRecentGrantAgreementWorker(action) {
  yield put({type: actionTypes.fetchRecentAgreementLoadingType});
  try {
    const response = yield call(fetchAccountData, action.payload);
    yield put({ type: actionTypes.fetchRecentAgreementSuccessType, payload: response.data });
  } catch (error) {
    yield put({ type: actionTypes.fetchRecentAgreementFailType, error });
  }
}

export function* fetchRecentGrantAgreementWatcher() {
  yield takeEvery(actionTypes.fetchRecentAgreementType, fetchRecentGrantAgreementWorker);
}

export function* fetchSavedCharityAgreementWorker(action) {
  try {
    const response = yield call(fetchAccountData, action.payload);
    yield put({ type: actionTypes.fetchSavedCharitySuccessType, payload: response.data });
  } catch (error) {
    yield put({ type: actionTypes.fetchSavedCharityFailType, error });
  }
}

export function* fetchSavedCharityAgreementWatcher() {
  yield takeEvery(actionTypes.fetchSavedCharityType, fetchSavedCharityAgreementWorker);
}

export function* grantHistoryAgreementWorker(action) {
  try {
    const response = yield call(fetchAccountData, action.payload);
    yield put({ type: actionTypes.fetchGrantHistorySuccessType, payload: response.data });
  } catch (error) {
    yield put({ type: actionTypes.fetchGrantHistoryFailType, error });
  }
}

export function* fetchGrantHistoryAgreement() {
  yield takeLatest(actionTypes.fetchGrantHistoryType, grantHistoryAgreementWorker);
}

export function* pendingGrantAgreementWorker(action) {
  try {
    const response = yield call(fetchAccountData, action.payload);
    yield put({ type: actionTypes.fetchPendingAgreementSuccessType, payload: response.data });
  } catch (error) {
    yield put({ type: actionTypes.fetchPendingAgreementFailType, error });
  }
}
export function* fetchPendingGrantAgreement() {
  yield takeLatest(actionTypes.fetchPendingAgreementType, pendingGrantAgreementWorker);
}

export function* removeCharityAgreementWorker(fetchPayload) {
  try {
    const response = yield call(postCharityData, fetchPayload);
    yield put({ type: actionTypes.removeCharitySuccessType, payload: fetchPayload  });
    if (fetchPayload.successFn) {
      fetchPayload.successFn();
    }
  } catch (error) {
    yield put({ type: actionTypes.removeCharityFailType, payload: error });
  }
}
export function* removeCharityAgreementWatcher() {
  yield takeEvery(actionTypes.removeCharityType, removeCharityAgreementWorker);
}

export function* postSearchCharityAgreementDataWorker(fetchPayload) {
  try {
    const response = yield call(postCharityData, fetchPayload);
    const serverDown = response.data === "The system is temporarily unavailable";
    if (typeof response.data === 'string') {
      yield put({
        type: actionTypes.postCharitySearchSuccessType,
        payload:{ hits: [], serverDown }
      });
    }
    yield put({
      type: actionTypes.postCharitySearchSuccessType,
      payload: { ...response.data.data, serverDown }
    });
    
  } catch (error) {
    yield put({ type: actionTypes.postCharitySearchFailType, payload: error });
  }
}

export function* postSearchCharityAgreement() {
  yield takeEvery(actionTypes.postCharitySearchType, postSearchCharityAgreementDataWorker);
}

function* fetchAccountDataAgreementWorker(fetchPayload) {
  try {
    const fetchObj = fetchPayload.payload.metaData;
    const fetchUrls = fetchPayload.payload.metaData.url;
    const fetchArr = [];
    for (const key in fetchUrls) {
      if (Object.prototype.hasOwnProperty.call(fetchUrls, key)) {
        const keyObj = Object.assign({
          method: fetchObj.method,
          url: fetchUrls[key]
        });
        fetchArr.push(keyObj);
      }
    }

    const fetchedArr = yield all(
      fetchArr.map(each => call(fetchAccountData, each))
    );

      yield put({
        type: actionTypes.accountDataSuccessType,
        payload: fetchedArr[0].data,
      });
      const poolsObj = formPoolStructure(fetchedArr[0].data.investmentPools);
      yield put({
        type: actionTypes.makeFromPoolsType,
        payload: poolsObj,
      })
    
  } catch (error) {    
    yield put({
      type: actionTypes.accountDataRequestFailedType,
      error
    });
  }
}

//search charity


function* fetchAccountDataAgreementWatcher() {
  yield takeEvery(actionTypes.fetchAccountDataType, fetchAccountDataAgreementWorker);
}

function* saveGrantAgreementWorker(action) {
  try {
    const response = yield call(postCharityData, action);
    yield put({ type: actionTypes.saveAgreementSuccessType, payload: response.data });
    action.successFn && action.successFn(response.data);
  } catch(error) {
    yield put({ type: actionTypes.saveAgreementFailType, payload: [] });
  }
}
function* saveGrantAgreementWatcher() {
  yield takeLatest(actionTypes.saveAgreementType, saveGrantAgreementWorker);
}


export function* fetchSearchGemini() {
  yield takeEvery(actionTypes.searchGeminiType, fetchSearchGeminiDataWorker);
}

export function* fetchSearchGeminiDataWorker(fetchPayload) {
  try {
    const response = yield call(fetchAccountData, fetchPayload.payload);
    if ((typeof response.data === "string" && response.data.length===0) || (typeof response.data.message==="string"))  {
      yield put({ type: actionTypes.searchGeminiSuccessType, payload: [] });
    }
    else if (typeof response.data === "string" && response.data.length>0) {
      yield put({ type: actionTypes.searchGeminiSuccessType, payload: response.data });
    }
    yield put({ type: actionTypes.searchGeminiSuccessType, payload: response.data });
  } catch (error) {
    yield put({ type: actionTypes.searchGeminiFailType, payload: error });
  }
}

export function* postSearchCity() {
  yield takeEvery(actionTypes.postCitySearchType, postSearchCityDataWorker);
}


export function* postSearchCityDataWorker(fetchPayload) {
  try {
    const response = yield call(fetchAccountData, fetchPayload.payload);
    yield put({ type: actionTypes.postCitySearchSuccessType, payload: response.data });
  } catch (error) {
    yield put({ type: actionTypes.postCitySearchFailType, payload: error });
  }
}

export function* postSearchCounty() {
  yield takeEvery(actionTypes.postCountrySearchType, postSearchCountyDataWorker);
}

export function* postSearchCountyDataWorker(fetchPayload) {
  try {
    const response = yield call(fetchAccountData, fetchPayload.payload);
    yield put({
      type: actionTypes.postCountrySearchSuccessType,
      payload: response.data
    });
  } catch (error) {
    yield put({ type: actionTypes.postCountrySearchFailType, payload: error });
  }
}

export function* updateLoadMoreFrom() {
  yield takeEvery(actionTypes.updateFromLoadingCounterType, updateFromLoadMoreWorker);
}
export function* updateFromLoadMoreWorker(fetchPayload) {
  yield put({
    type: actionTypes.updateFromLoadMoreCounterType,
    payload: fetchPayload
  });
}

export function* submitSavedDataWatcher() {
  yield takeEvery(actionTypes.saveCharityType, submitSavedDataWorker);
}

export function* submitSavedDataWorker(action) {
  try {
    const response = yield call(grant.suggestCharity, action.payload);
    const { charityData } = action.payload;
    yield put({ type: actionTypes.saveCharitySuccessType, 
      payload: response.data,
      prevData: charityData
    });
    if (action.successFn) {
      action.successFn(response.data);
    }
  } catch (error) {
    const { charityData } = action.payload;
    yield put({ type: actionTypes.saveCharityFailType,
      payload: error,
      prevData: charityData
    });
  }
}

export function* submitSavedGeminiDataWatcher() {
  yield takeEvery(actionTypes.postGeminiSavedDataType, submitSavedGeminiDataWorker);
}

export function* submitSavedGeminiDataWorker(action) {
  try {
    const response = yield call(grant.addCharity, action.payload);
    const { charityData } = action.payload;
    yield put({
      type: actionTypes.postGeminiSavedDataSuccessType,
      payload: response.data,
      prevData: charityData
    });
    if (action.successFn) {
      action.successFn(response.data);
    }
  } catch (error) {
    const { charityData } = action.payload;
    yield put({ type: actionTypes.postGeminiSavedDataFailType, 
      payload: error,
      prevData: charityData
    });
  }
}

export function* fetchPoolsWatcher() {
  yield takeEvery(actionTypes.fetchPoolsType, fetchPoolsWorker);
}

export function* fetchPoolsWorker(fetchPayload) {
  try {
    const response = yield call(fetchAccountData, fetchPayload.payload);
    yield put({
      type: actionTypes.fetchPoolSuccessType,
      payload: response.data.investmentPools
    });
  } catch (error) { }
}

export function* addCharityWatcher() {
  yield takeLatest(actionTypes.addCharityType, addCharityWorker);
}

export function* addCharityWorker(action) {
  try {
    const response = yield call(grant.addCharity, action.payload);
    const charityData = action.selectedCharity;
    yield put({ type: actionTypes.addCharitySuccessType,
      payload: response.data,
      prevData: charityData
    });
    if (action.successFn) {
      action.successFn(response.data);
    }
  } catch (error) {
    const charityData = action.selectedCharity;
    yield put({ type: actionTypes.addCharityFailType,
      payload: error,
      prevData: charityData
    });
  }
}

export default function* grantAgreementWatcher() {
  yield all([
    fork(fetchAccountDataAgreementWatcher),
    fork(confirmationDataWatcher),
    fork(fetchSearchGemini),
    fork(postSearchCity),
    fork(postSearchCounty),
    fork(fetchSavedCharityAgreementWatcher),
    fork(fetchRecentGrantAgreementWatcher),
    fork(fetchGrantHistoryAgreement),
    fork(fetchPendingGrantAgreement),
    fork(removeCharityAgreementWatcher),
    fork(postSearchCharityAgreement),
    fork(saveGrantAgreementWatcher),
    fork(submitSavedDataWatcher),
    fork(updateLoadMoreFrom),
    fork(fetchGrantDetails),
    fork(submitSavedGeminiDataWatcher),
    fork(fetchPoolsWatcher),
    fork(addCharityWatcher)
  ]);
}